import { Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useUserSettings } from '../../../../../../../hooks'
import { AppointmentFormData } from '../../../../../../../types'

const dateOptions: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  month: 'short',
  day: 'numeric',
}

const DateTitle = () => {
  const { locale } = useUserSettings()
  const { watch } = useFormContext<AppointmentFormData>()
  const clientStartDate = watch('clientStartDate')
  const formattedDate = clientStartDate ? clientStartDate?.toLocaleDateString(locale, dateOptions) : ''

  return (
    <Typography variant="h3" sx={{ pt: '0.25rem' }}>
      {formattedDate}
    </Typography>
  )
}

export { DateTitle }
